import { camelizeRespDataKeys } from '@common/utils'
import restApi from '@infrastructure/api/restApi'

export default {
  getPreviews: () =>
    restApi.get('/admin/panel/previews').then(camelizeRespDataKeys)
}
